import React, { Fragment, useEffect, useState, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { buildPackageOpenGraph } from '@blocktickets/shared-utils'

import LoadingContext from '../../context/Loading/Loading'

import { getPackageFE } from '../../utilities/api'
import { ensureWaitingRoomAccess } from '../../utilities/waitingRoom'
import { resolvePrimaryColor } from '../../components/PurchaseFlow/utils/branding'
import { cacheOrgBranding } from '../../utilities/orgBrandingCache'

import { PageLoadingContainer, ViewPackageWrapper } from '../../components'
import OpenGraph from '../../components/OpenGraph/OpenGraph'
import NotFoundPage from '../NotFoundPage/NotFoundPage'

export default function ViewPackagePage() {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)
  const navigate = useNavigate()

  let { slug, id } = useParams()

  const [eventPackage, setEventPackage] = useState()
  const [purchaseLog, setPurchaseLog] = useState()
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    let redirected = false
    setNotFound(false)
    showLoading()
    getPackageFE(id)
      .then((res) => {
        const { eventPackage: pkg, purchaseLog: log } = res.data
        if (!pkg) {
          setNotFound(true)
          return
        }
        const returnPath = `/venue/${slug || pkg?.venue?.slug}/package/${id}`
        if (ensureWaitingRoomAccess(navigate, pkg?.events, returnPath)) {
          redirected = true
          return
        }
        setEventPackage(pkg)
        setPurchaseLog(log)
        cacheOrgBranding(pkg?.organization)
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          setNotFound(true)
          return
        }
        console.error(err)
      })
      .finally(() => {
        if (!redirected) {
          setTimeout(() => hideLoading(), 700)
        }
      })
  }, [id, slug, navigate])

  const themeColor = resolvePrimaryColor(null, eventPackage?.organization)
  const openGraph = buildPackageOpenGraph(eventPackage)

  return (
    <Fragment>
      <OpenGraph {...openGraph} />
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <meta name="theme-color" content={themeColor} />
        <meta
          name="keywords"
          content={`Season tickets and packages for ${
            eventPackage?.organization?.name ||
            eventPackage?.venue?.name ||
            'events'
          }`}
        />
      </Helmet>
      {isLoading ? (
        <PageLoadingContainer organization={eventPackage?.organization} />
      ) : notFound ? (
        <NotFoundPage />
      ) : (
        <section className="full-height">
          <ViewPackageWrapper
            eventPackage={eventPackage}
            purchaseLog={purchaseLog}
          />
        </section>
      )}
    </Fragment>
  )
}
